// extracted by mini-css-extract-plugin
export default {"container":"NotSearchResultsPage_container__zItb4","row":"NotSearchResultsPage_row__Uqlqa","h1":"NotSearchResultsPage_h1__I4il1","h2":"NotSearchResultsPage_h2__soqEA"};